<template>
  <ul class="configurator-step-list" :class="showScroll && 'show-scroll'" @mouseenter="showScroll = true" @mouseleave="showScroll = false">
    <ConfiguratorStepListItem
      v-if="options"
      v-for="(item, index) in priorityOptions"
      v-bind:item="item"
      v-bind:option="name"
      v-bind:key="item.id"
    />

    <div class="spacer" v-if="options && priority"></div>

    <ConfiguratorStepListItem
      v-if="options"
      v-for="(item, index) in restOptions"
      v-bind:item="item"
      v-bind:option="name"
      v-bind:key="item.id"
    />
  </ul>
</template>

<script>
import ConfiguratorStepListItem from "./ConfiguratorStepListItem";

export default {
  name: "ConfiguratorStepList",
  components: { ConfiguratorStepListItem },
  props: ["name", "options", "priority"],
  data: function() {
    return {
      showScroll: false
    };
  },
  computed: {
    priorityArray: function() {
      return this.priority.split(",");
    },
    priorityOptions: function() {
      if (this.priority && this.options) {
        return this.options.filter(
          function(element) {
            return this.priorityArray.indexOf(element.name) >= 0;
          }.bind(this)
        );
      } else {
        return [];
      }
    },
    restOptions: function() {
      if (this.priority && this.options) {
        return this.options.filter(
          function(element) {
            return this.priorityArray.indexOf(element.name) < 0;
          }.bind(this)
        );
      } else {
        return this.options;
      }
    }
  }
};
</script>

<style scoped>

* {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}
*:hover {
  scrollbar-width: thin;
  scrollbar-color: #999999 transparent;
}
*::-webkit-scrollbar {
  width: 8px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 20px;
}
*::-webkit-scrollbar-thumb:hover {
  background-color: #999999;
}

ul {
  margin: 0;
  padding: 10px 0 30px 0;
  list-style-type: none;
  position: absolute;
  top: 62px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.spacer {
  height: 5px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepList.vue